import { useQuery } from '@tanstack/react-query';
import { useDebounce } from '@hooks/useDebounce';
import { Employee } from '@models/employee.model';
import { employeesService, EmployeesFilter } from '@services/employees';

export const EMPLOYEES_QUERY_KEY = ['employees'];

export const useEmployees = (filter?: EmployeesFilter) => {
  const debouncedText = useDebounce(filter?.text ?? '', 500);
  const effectiveFilter: EmployeesFilter | undefined = filter
    ? { ...filter, text: debouncedText }
    : undefined;

  return useQuery<
    {
      employees: Employee[];
      total: number;
      page: number;
      limit: number;
    },
    Error
  >({
    queryKey: [...EMPLOYEES_QUERY_KEY, effectiveFilter || 'all'],
    queryFn: async () => {
      return await employeesService.getEmployees(effectiveFilter);
    },
    staleTime: 5 * 60 * 1000, // Data is fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Cache for 10 minutes
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on mount if data exists
  });
};
